import { useEffect, useState } from 'react';
import MainTable from "./scout/pages/Table";

const ScanView = () => {
  const [preload, setPreload] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setPreload(false), 1000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="d-flex justify-content-left">
      <div className="page">
        <MainTable />
      </div>
    </div>
  );
};

export default ScanView;